import type { PropsWithChildren } from 'react';
import type React from 'react';

import { Link } from '@change/ds-core-ui';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';
import type { QrCodeType } from '@change-corgi/middle-end-gql-schema';

import { getPetitionQRCode } from 'src/app/shared/hooks/qrcode';

import { useAsyncDownload } from '../hooks/useAsyncDownload';

export const PetitionQRCodeDownloadLink: React.FC<
	PropsWithChildren<{
		slugOrId: string;
		type: QrCodeType;
		size?: number;
		filename?: string;
		/**
		 * @deprecated Use onClick instead.
		 */
		onDownload?: () => Promise<void>;
		onClick?: () => Promise<void>;
	}>
> = ({ children, slugOrId, size, type, filename, onDownload, onClick }) => {
	const utilityContext = useUtilityContext();

	const { actions } = useAsyncDownload({
		fetchData: async () => {
			const result = await getPetitionQRCode({
				slugOrId,
				type,
				size,
				utilityContext,
			});
			return { dataUri: result.imageBase64Uri };
		},
		filename: filename || 'petition-qrcode.png',
		onDownload: onClick || onDownload,
	});

	return (
		<Link
			href="#"
			onClick={actions.handleDownload}
			bold
			size="small"
			variant="secondary"
			data-qa="qrcode-download-link"
			data-testid="qrcode-download-link"
			preventScrollReset
		>
			{children}
		</Link>
	);
};
